import { useState } from 'react';
export function useSelect({ value, onChange, multiple, }) {
    const [isOpen, setOpen] = useState(false);
    const handleClear = (e) => {
        e.stopPropagation();
        onChange(null);
    };
    const handleSelect = (option) => {
        if (multiple) {
            let currentValues = (value ?? []);
            const optionIndex = currentValues.findIndex(v => v.id === option.id);
            if (currentValues.length === 1 && optionIndex !== -1) {
                // @ts-expect-error needs to be null to render the placeholder
                currentValues = null;
            }
            else if (optionIndex !== -1) {
                currentValues.splice(optionIndex, 1);
            }
            else {
                currentValues.push(option);
            }
            onChange(currentValues);
        }
        else {
            onChange(option);
        }
        if (!multiple) {
            setOpen(false);
        }
    };
    const isSelected = (option) => {
        if (multiple) {
            return value?.some(v => v.id === option.id);
        }
        return option.id === value?.id;
    };
    return {
        isOpen,
        setOpen,
        handleClear,
        handleSelect,
        isSelected,
    };
}
